import React from 'react';
import CoveragePanel from '../../../panels/coverage/CoveragePanel';
import Container from './styles/Container';

function CoverageView() {
  return (
    <Container>
      <CoveragePanel />
    </Container>
  );
}

export default CoverageView;
